/*
 * Copyright (c) 2017-2018. Code réalisé par IpsoSenso
 */

import { flatten } from 'flat'
import { messages as messagesIsotope } from 'isotope-client'
import { RESULTATS_EXAMEN_CCAP } from '../modules/examens/services/examens.enums'


export default flatten({
	...messagesIsotope,
	accueil: 'Accueil',
	parent: 'Parent',
	headers: {
		pieceJustificative: 'Supporting document',
		piecesJustificatives: 'Supporting documents',
		recue: 'Received'
	},
	menu: {
		etatCivil: 'My civil status',
		examens: 'My exams',
		historique: 'My history',
		motDePasse: 'My password',
		contacts: 'My contact DGAC',
		informations: 'Information'
	},
	tooltip: {
		manuel: 'Manual',
		deconnexion: 'Logout',
		numeroSigebel: 'To be completed only if you hold a French FCL license (ex: F-LAA00654321). <br /> The SIGEBEL number (or license file number) is the 8-character numeric part of your French FCL license number (ex: F-LAA00654321-> 00654321).',
		'changer-profil': 'Change profile'
	},
	form: {
		motDePasse: {
			champs: {
				identifiant: 'Login (email address entered in OCEANE) *',
				motDePasseActuel: 'Current password *',
				nouveauMotDePasse: 'New password *',
				confirmerMotDePasse: 'Confirmation of the new password *'
			},
			erreurs: {
				motDePasseIncorrect: 'Incorrect password',
				nouveauMotDePasse: 'Your password must be at least 8 characters long and must contain at least one digit, one lower case and one uppercase letter',
				confirmerMotDePasse: 'The new password and its confirmation are different',
				tokenInvalide: 'The link is outdated. Please make a new request.'
			},
			warning: 'Remember your password which is personal and confidential. For security reasons, it will not be recalled to you',
			succes: 'Password saved',
			renouveler: 'Renouveler votre mot de passe', // La page de renouvellement du mot de passe ne peut pas apparaître en anglais
			genererSucces: 'You will receive an email if your email address is valid.',
			generer: 'Generate a new password' // La page de génération d'un nouveau mot de passe ne peut pas apparaître en anglais
		},
		creerCompte: {
			titre: 'Create an Oceane account'
		},
		global: {
			erreurs: {
				obligatoire: 'Mandatory field'
			}
		}
	},
	connexion: {
		authentification: 'Authentication',
		identifiant: 'Oceane ID or email address *',
		motDePasse: 'Password *',
		motDePasseOublie: 'Forgotten password',
		cliquerIci: 'click here',
		autreProblemeConnexion: 'For all other login problems, send an email to:',
		creerCompte: 'Create account',
		meConnecter: 'Login',
		creationCompteSucces: 'Your account has been successfully created. An email has been sent to you, containing your credentials.'
	},
	candidats: {
		profil: {
			tabs: {
				etatCivil: 'Civil status'
			},
			etatCivil: {
				numeroCandidat: 'Candidate number',
				civilite: 'Title',
				nomNaissance: 'Birth name',
				prenomPrincipal: 'First name',
				dateNaissance: 'Date of birth',
				email: 'Email',
				numeroSigebel: 'No. SIGEBEL',
				nomUsage: 'Spouse\'s name or surname',
				autresPrenoms: 'Middle names',
				villeNaissance: 'City of birth',
				nationalite: 'Nationality',
				adresseLigne1: 'Address line 1',
				adresseLigne2: 'Address line 2',
				adresseLigne3: 'Address line 3',
				codePostal: 'Postal code',
				ville: 'City',
				pays: 'Country',
				telephone: 'Phone number',
				autre: 'Secondary phone number',
				telecopie: 'Fax number',
				identite: 'Identity document',
				modification: 'Dernière modification le {date} par {nom}',
				infoErreur: 'If you find an error in your civil status, please report it to the examination centre of Orly ({mail})',
				infoNavigation: 'To navigate on the website, use the menu : « My civil status », « My exams » « My history », ...',
				etatCivilError: {
					title: 'Important',
					text: 'Email address and/or phone number are missing. These data are mandatory for futures subscriptions.'
				},
				updateEmail: 'Update my email address',
				updateEmailDialog: {
					title: 'Email address updating',
					password: 'Password',
					email: 'New email',
					success: 'An email was sent to the new email address for validation'
				}
			},
			examens: {
				piecesJustificatives: 'Supporting documents',
				inscriptions: {
					piecesJustificatives: {
						filAriane: 'Supporting documents'
					},
					erreurs: {
						examenNonEcran: 'This exam cannot be taken on a computer'
					},
					missingInfo: 'Email address and/or phone number are missing. These data are mandatory for futures subscriptions.'
				}
			}
		}
	},
	examens: {
		titre: 'My exams',
		aide: '<b>Purpose (only for theoretical knowledge examinations)</b><ul><li>Passing the examination : you are registred to this exam in order to get the matching diploma.</li><li>Subject validation : you are registred to this exam in order to validate one or several of its subjects.</li></ul><br/><b>Status</b> : it indicates the status of your examination :<ul><li>Created : the examination is created but there is no registration for it yet.</li><li>On progress : one or several registration(s) have been made for the examination.</li><li>Passed : the examination has been passed.</li><li>Printed : if you have sat for a theoretical knowledge examination, the diploma is printed; if you have done a skill test, your file has been transmitted to the licensing office.</li><li>Given up : the examination has been given up meanwhile.</li><li>Failed : the examination has been failed, (for others reasons than cheating).</li><li>Fraude : the examination has been failed due to cheating.</li></ul>\n',
		objectif: {
			1: 'Exam pass (fixed rate)',
			2: 'Subjects validation (rate per subject)'
		},
		etat: {
			1: 'Created',
			2: 'In progress',
			3: 'Passed',
			4: 'Failed',
			5: 'Printed',
			6: 'Given up',
			7: 'Fraud'
		},
		le: ' on ',
		certificat: 'Certificate',
		resultats: {
			btn: 'Results',
			popin: {
				titre: "Exam's Results",
				[RESULTATS_EXAMEN_CCAP.SCO]: "First aid Mark",
				[RESULTATS_EXAMEN_CCAP.SCU]: "Safety Mark",
				[RESULTATS_EXAMEN_CCAP.ELIMINATION]: "Pool elimination",
				noteEpreuve: "{note} / 20",
				booleanElimination: {
					true: 'Yes',
					false: 'No'
				}
			}
		},
		nouveau: {
			titre: 'New exam',
			categorie: 'Select category',
			examenType: 'Exam',
			categorieExamenType: {
				1: 'Theoretical knowledge examinations (commercial pilots)',
				2: 'Skill test',
				3: 'Language proficiency',
				4: 'Theoretical knowledge examination (private pilots)'
			},
			check: 'I have read the information regarding this exam.',
			erreur: {
				dejaExistant: 'You already have an onging or initiated examination for this type of examination. Please refer to your exam list.'
			}
		}
	},
	inscriptions: {
		title: 'Subscriptions to this exam',
		aide: '<b>Status</b>: it indicates the current status of your registration: <ul><li>Created, Frozen = the subscription was created; it\'s about to be assigned to a site</li><li>Assigned = the subscription has been assigned to a site</li><li>In progress = the tests are in progress</li><li>Completed = all the subjects have been completed</li><li>Given up = the subscription was abandoned before completion</li></ul>',
		aidePratique: '<b>Status</b>: it indicates the current status of your registration: <ul><li>Created: the registration is created</li><li>On progress: the registration is on progress.</li><li>Completed: the registration has been completed.</li><li>Given up: the registration  has been given up.</li></ul>',
		aideValidationEpreuves: '<span class="titre">For all new subscription, you can:</span><ul><li>Fill and send a form to the examination centre of the DGAC (the forms of inscription are available on our institutional site <a href="http://www.aviation-civile.gouv.fr">www.aviation-civile.gouv.fr</a>)</li><li>Address it directly to the examination centre of Orly</li></ul>\n',
		etat: {
			1: 'Created',
			2: 'Frozen',
			3: 'Assigned',
			4: 'In progress',
			5: 'Completed',
			6: 'Given up'
		},
		type: {
			1: 'Computer',
			2: 'Paper',
			3: 'Mixed',
			4: 'Practical'
		},
		piecesJustificativesDossier: {
			title: 'Your supporting documents',
			button: 'Supporting documents',
			statutDossier: {
				1: 'Your supporting documents need to be completed so that your registration can be validated. Please transmit them to us using the link below.',
				2: 'Your supporting documents are currently being verified. An email will be sent to you as soon as we have validated them.',
				3: 'Some of the attached files are non-compliant. You are invited to replace them using the link below.',
				4: ' Your documents have been validated. You may attend the examination under the conditions mentioned in your registration sheet accessible on this page.'
			},

			warningNonConforme: {
				title: 'Non-compliant file'
			},
			infosComplementaires: {
				title: 'Additional information',
				form: {
					noTelepilote: 'Your remote pilot number *',
					dateExpirationCertifBapd: 'Expiration date of your BAPD certificate *',
					dateExpirationCertifA1A3: 'Expiration date of your Open A1/A3 certificate *',
					isTitulaireBapd: 'Do you hold the BAPD certificate? *',
					erreurs: {
						noTelepiloteSuffixeNbCaracteres: 'Please enter 12 alphanumeric characters',
						certifExpireAvantDerniereEpreuve: 'Your A1/A3 certificate expires before your final exam'
					},
					buttons: {
						envoyer: 'Submit'
					}
				}
			},
			listePJ: {
				title: 'Submission of the supporting documents',
				warning: {
					title: 'Important',
					description: (
						'The documents you provide must have one of the following extensions: <Strong>.pdf .jpg .jpeg .png .gif</Strong><br>' +
						'They must be of <Strong>good quality</Strong> and oriented in the <Strong>direction of reading</Strong>.<br>' +
						'Each document must not exceed <Strong>20 MB</Strong>.'
					)
				},
				status: {
					nonConforme: 'non-compliant',
					validee: 'validated',
				},
				fileNotExist: 'The file was deleted'
			},
			envoyer: {
				dossierNonComplet: 'All mandatory documents must be provided to submit your application'
			},
			messages: {
				createPjSuccess: 'The following supporting document was successfully uploaded: {fileName}',
				deletePjSuccess: 'The following supporting document was successfully deleted: {fileName}',
				dossierValideSuccess: 'The application has been submitted for validation',
			}
		},
		vosInscriptions: {
			title: 'Your subscriptions'
		},
		sessionPapier: 'Paper session {libelleSession}',
		passageEcran: 'Computer exam from {dateDebut} to {dateFin}',
		passageEcranShort: 'From {dateDebut} to {dateFin}',
		inscription: 'Subscription',
		inscriptionType: '{type} subscription',
		lettreResultat: 'Results letter',
		convocation: 'Convocation',
		piecesJustificatives: 'Supporting documents',
		ficheInscription: 'Inscription summary',
		ficheRecap: 'Inscription recap',
		aucune: 'There are no subscriptions for this exam',
		nouveau: {
			title: 'New subscription',
			ecran: 'Computer',
			papier: 'Paper',
			session: 'Session',
			niveau6: 'Level 6',
			erreurs: {
				examenEchoueNonExceptionnel: 'Only exceptional subscriptions are allowed for a failed exam',
				examenTermine: 'No new subscriptions can be created for an exam that has been passed, edited, given up or declared as fraud',
				inscriptionsNonFinales: 'The current subscription must be finished before creating a new one',
				delaiDepasse: 'The chosen session exceeds the maximum time for obtaining the exam',
				examenTypeDesactive: 'New subscriptions to this exam are not allowed anymore',
				examenNonEcran: 'This exam cannot be taken on a computer'
			},
			avertissement: {
				title: 'You are about to register for a <Strong>{examenType}</Strong>:',
				message: '<ul><li> 1) Make sure that the skill test you have selected is the correct one because once the registration is completed, no further change can be done. If you have made a mistake on the selected skill test, stop the registration by clicking on the « ANNULER » (CANCEL) button.</li><li> 2) The registration will be completed only when the payment is accepted. Make sure that your credit card is easily accessible because your connexion time is limited.</li><li>3) WARNING: once the registration is completed, it can neither be changed, nor be reimbursed. Make sure that you have selected the right skill test and that you have correctly filled in the blanks.</li><li> 4) Press « OK » to continue.</li></ul>',
				inscriptionAttentePaiement: 'You have already attempted to register for an examination during the day. Your registration is awaiting confirmation of payment.<br/>' +
					'<br/>' +
					'If you have  received a receipt of payment by e.mail, it means that your registration will soon be confirmed. An e.mail confirming your registration will be sent to you within two hours.<br/>' +
					'<br/>' +
					'If you have not confirmed your payment, we invite you to renew your registration process the next morning.<br/>' +
					'<br/>' +
					'We draw to your attention that any request you would have to make to the Examination Department in Orly needs that you strictly follow the rules mentioned above to be considered.<br/>'
			}
		},
		payfip: 'Votre paiement a été accepté. Votre inscription est en cours. Pour la valider, merci d\'envoyer au plus vite les pièces justificatives.',
		warningKsaTitle: 'Warning if you intend to make a first subscription to this exam after 08/01/2021',
		warningKsa: 'Since August 1, 2021, all new registration for a first theoretical examination test must comply with the new training objectives 100KSA.<br/>' +
			'Exams corresponding to the old knowledge objectives :<br/>' +
			'Since that date, only candidates who have registered for at least one test are authorized to continue ATPL, CPL or IR examinations corresponding to the former training objectives. All the topics of the exam (ATPL, CPL or IR) must be passed before July 31, 2022.<br/>' +
			'At this date, if the candidate has not passed all the tests of the theoretical exam, he will lose the benefit of the tests passed.<br/>' +
			'<br/>' +
			'Theoretical test equivalence between old exams and 100KSA exams :<br/>' +
			'Pursuant to AMC FCL.025(a)(2), a candidate must attend full training 100KSA before taking the exam.<br/>' +
			'The ATO must certify that the candidate has followed the full training and satisfied to the objectives of this training, as well as for the subjects for which the equivalence is requested.<br/>' +
			'<br/>' +
			'Specific case for the communication test : Only candidates who have passed the communications VFR (091) + IFR (092) will benefit from the equivalence (090)<br/>'

	},
	scenarioEpreuve: {
		ato: 'ATO',
		examinateur: 'Examiner',
		compagnie: 'Air operator'
	},
	mode: {
		passage: {
			epreuve: {
				simulateur: 'Simulator',
				simulateurAppareil: 'Simulator and aircraft',
				appareil: 'Aircraft'
			}
		}
	},
	nouvelleInscriptionPratique: {
		etapes: {
			2: {
				stepperLabel: 'Detail',
				title: 'Skill test details',
				form: {
					examen: {
						label: 'Exam'
					},
					date: {
						label: 'Planned date for the skill test *',
						error: 'The date you have selected does not comply with the required 21 days before the date of the skill test'
					},
					ato: {
						label: 'ATO'
					},
					aeronef: {
						label: 'Aircraft *'
					},
					examinateur: {
						info: 'You must select a date and an aircraft for the test before selecting an examiner.',
						label: 'Suggested examiner *',
						francais: 'French examiners',
						etrangers: 'Foreign examiners',
						error: 'The date planned for the skill test is not consistent with the validity of the qualifications and the privileges of the examiner examiner'
					},
					suppleant: {
						label: 'Substitute exanminer',
						error: 'The date planned for the skill test is not consistent with the validity of the qualifications and the privileges of the substitute examiner.'
					},
					atplOnly: 'for ATPL only',
					modePassage: {
						label: 'Way of doing the skill test *'
					},
					lieu: {
						label: 'Place'
					},
					scenario: {
						label: 'Scenario'
					},
					organisme: {
						label: 'ATO / examiner name'
					}
				}
			},
			3: {
				stepperLabel: 'Attachment',
				title: 'List of supporting documents to be provided by the candidate',
				privilege: {
					examinateur: 'Information : the privileges and qualifications of the suggested examiner will expire less than 10 days after the date planned for the skill test.',
					suppleant: 'Information : the privileges and qualifications of the substitute examiner will expire less than 10 days after the date planned for the skill test.'
				},
				button: {
					imprimer: 'Print',
					regler: 'Pay'
				}
			}
		}
	},
	nouvelleInscription: {
		title: 'New {examenType} subscription',
		// Les 3 étapes de la création d'une nouvelle inscription
		etapes: {
			0: {
				title: ''
			},
			1: {
				stepperLabel: 'Subjects',
				title: 'Selection of the subscription\'s subjects',
				legende: {
					title: 'Legend',
					rouge: 'Formation refused by your school',
					vert: 'Subject already passed'
				},
				anglais: 'English',
				erreurs: {
					aucuneEpreuveSelectionnee: 'You must select at least one subject',
					formationObligatoire: 'You must be following studies for the subjects you are attempting to pass',
					approbationFormationObligatoire: 'Passing this exam requires that all subjects have been approved by your school'
				}
			},
			2: {
				stepperLabel: 'Centre',
				titleCriteres: 'Criteria',
				titleProposition: 'Proposal',
				titleSelection: 'Exam centre selection',
				siteEcran: 'Computer site *',
				dateAuPlusTot: 'Soonest date *',
				dateTooltip: 'The soonest date is the day on which you would like to begin your tests. You are not allowed to make reservations after {date}',
				rythme: {
					1: 'Speed rhythm',
					2: 'Zen rhythm'
				},
				nbJoursMax: 'Maximum number of days for the subscription',
				nbEpreuvesMax: 'Maximum number of subjects per day',
				session: 'Session',
				choix1: '1st choice *',
				choix2: '2nd choice *',
				erreurs: {
					delaiMinimumInscriptionEcran: 'The subscription must be made at least {0} days before the date of the first test',
					creneauxInsuffisants: 'The availabilities are not sufficent to plan all the requested subjects while fulfilling the criteria',
					maxMoisEpreuveAtteint: 'A subscription planning can\'t be found within the remaining time to complete the exam',
					delaiMaximumAtteint: 'The reservations are not authorized beyond {0} days',
					choixCentresIdentiques: 'The two chosen centres must be different',
					dateLimiteKSA: 'Vous ne pouvez pas passer la première épreuve d\'un examen professionnel nouvelle formule avant le {dateLimite}',
					dateLimiteAvantKSA: 'Vous ne pouvez pas passer la première épreuve d\'un examen professionnel ancienne formule après le {dateLimite}',
					dateAuPlusTotAvantDateDebutPassage: 'The soonest date cannot come before {dateDebutPassage}, which is the earliest allowed date for this exam',
					dateAuPlusTotApresDateFinPassage: 'The soonest date cannot come after {dateFinPassage}, which is the latest allowed date for this exam',
					creneauxDepassentDateFinPassage: 'There are no availabilities on the selected site for this exam before {dateFinPassage}, which is the latest allowed date for this exam',
				},
				proposition: {
					noResult: 'The availabilities are not sufficent to plan all the requested subjects while fulfilling the criteria',
					creneau: '{date} from {heureDebut} to {heureFin}'
				},
				popupCalendrier: {
					titre: 'Monthly calendar',
					ferme: 'Closed day',
					reserve: 'Reserved day',
					nbReservations: 'Number of reservations',
					jours: {
						lundi: 'Monday',
						mardi: 'Tuesday',
						mercredi: 'Wednesday',
						jeudi: 'Thursday',
						vendredi: 'Friday',
						samedi: 'Saturday',
						dimanche: 'Sunday'
					}
				}
			},
			3: {
				stepperLabel: 'Payment',
				inscription: {
					non_payante: 'The royalties for your exam were already paid for within a former subscription.<br />Please validate to confirm the creation of the subscription.',
					paiement_differe: 'The royalties for your exam will be paid by your school.<br/>Please validate to confirm the creation of the subscription.'
				},
				delaiPaiement: 'You have 40 minutes to complete your payment. Beyond that, the registration will be deleted.<br/>Once your payment has been completed, you will receive a confirmation email.<br/>Should this email not reach you, please contact your DGAC contact to check whether your registration was taken into account by OCEANE.',
				montant: 'Registration fee',
				sitePaiementBtn: 'Go to payment site'
			}
		}
	},
	etatExamenCandidat: {
		0: ' ',
		1: 'Created',
		2: 'In progress',
		3: 'Passed',
		4: 'Failed',
		5: 'Printed',
		6: 'Given up',
		7: 'Fraud'
	},
	global: {
		btn: {
			annuler: 'Cancel',
			enregistrer: 'Save',
			supprimer: 'Delete',
			deconnexion: 'Logout',
			fermer: 'Close',
			retour: 'Back',
			valider: 'Validate',
			creer: 'Create',
			ok: 'OK',
			rechercher: 'Search',
			oui: 'Yes',
			non: 'No',
		},
		erreurs: {
			titre: 'Error',
			generic: 'An error occured',
			obligatoire: 'The field is mandatory',
			obligatoireSpecifique: 'The field {champ} is mandatory',
			formatEmail: 'The format of the email address is not correct',
			uniqueEmail: 'These accounts have the same email address : {0}',
			nom: 'The field should be filled in with alphanumerics, whitespaces, apostrophes or minus signs',
			alphaTiret: 'The field should be filled in with alphanumerics or minus signs',
			numeric: 'The field should only contain numerical characters',
			telephone: 'The field should only contain numerical characters and . , -, +, space',
			date: {
				invalid: 'La date {0} n\'est pas valide',
				format: 'Le champ doit être au format jj/mm/aaaa',
				superieurDateDuJour: 'La date doit être antérieure à la date du jour',
				anterieurDateDuJour: 'The date must be greater than or equal to the current date',
				dateDebutSuperieureDateFin: 'La date de début doit être antérieure à la date de fin',
				periodeTropLongue: 'La période ne doit pas excéder {nombre} {unite}'
			},
			import: {
				creationCr: 'An error occured while creating the report',
				colonne: 'The CSV file is incorrect : The column "{colonne}" has not been found.'
			},
			connexionImpossible: 'Connection failed',
			mauvaisIdentifiants: 'Bad credentials',
			examenTypeExistant: 'Le candidat possède déjà un examen en cours ou initialisé pour cet examen type',
			droitsInsuffisants: 'Vous ne possédez pas les droits d\'accès suffisants.',
			utilisateurNonExistant: 'Cet utilisateur n\'existe pas, veuillez contacter l\'administrateur de l\'application OCEANE afin de synchroniser avec l\'annuaire LDAP.',
			profilInconnu: 'Votre profil est inconnu, veuillez contacter l\'administrateur de l\'application OCEANE afin de synchroniser avec l\'annuaire LDAP.',
			sansOrganisme: 'Aucun organisme de formation ne vous est affecté. Merci de contacter l\'administrateur pour paramétrer vos droits.',
			snack: 'The form has errors',
			motDePasseIncorrect: 'Incorrect password',
			emailExistant: 'This email address already exists'
		},
		indications: {
			information: 'Information',
			informationImportante: 'Important information',
			selectEmpty: 'Select...'
		},
		civilite: {
			0: ' ',
			1: 'Mr',
			2: 'Mrs',
			3: 'Miss'
		}
	},
	btn: {
		logout: 'Logout'
	},
	notify: {
		success: 'Information saved',
		error: 'An error has occured'
	},
	updateEmail: {
		success: 'Your email address was updated with success',
		error: 'Your request could not be completed. The link you used may be out of date.'
	}
})
